export default "__VITE_ASSET__3df3e87c__"